<template>
  <v-btn dark block color="orange" @click="openSelectionModal">
    &nbsp;Selecionar Pagamentos&nbsp;
  </v-btn>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/services/event-bus';

export default {
  name: 'SelectAnticipationsButton',
  computed: {
    ...mapGetters({
      rule: 'user/automaticAnticipationEnabled',
    }),
  },
  methods: {
    openSelectionModal() {
      EventBus.$emit('anticipation.selection.modal.show');
    },
  },
  data() {
    return {};
  },
};
</script>
